import { berechneMietdauerTage } from './mietwagen-restschuld';

export interface MietwagenKPI {
  mietdauerTage: number;
  tagespreis: number | null;
  gesamtkosten: number | null;
}

export function berechneMietkosten(
  mietbeginn: string | null | undefined,
  mietende: string | null | undefined,
  tagespreis: number | null | undefined,
): MietwagenKPI {
  const mietdauerTage = berechneMietdauerTage(mietbeginn, mietende);
  const tagessatz = tagespreis ?? null;
  const gesamtkosten =
    mietdauerTage > 0 && tagessatz != null ? mietdauerTage * tagessatz : null;
  return { mietdauerTage, tagespreis: tagessatz, gesamtkosten };
}
